export enum ReportTypes {
  PATH_PERFORMANCE = 1,
  REFUND = 2,
  CUSTOM = 3,
  FAQ = 4,
  SESSION_SUMMARY = 5,
  CHARGEBACK = 6,
  MARKETPLACE = 7,
  RETENTION = 8,
  DASHBOARD = 9,
  RETENTION_DASHBOARD = 10,
  PAYMENT_UPDATER = 11,
  SP_CHARGEBACK = 12,
  SUBSCRIPTION_RETENTION = 13,
  ORDER_RETENTION = 14,
  RETURN_RETENTION = 15,
  CHATBOT = 16,
  GATEWAY_TRANSACTION = 17,
  ORDER_OPTIONS = 18,
  CUSTOMER_SUPPORT = 19,
  SINGLE_STEP = 20,
  TRAFFIC_SOURCE = 21,
  RESOLVE = 22,
}

export enum ReportDimensionCategories {
  Dimensions = 0,
}

export enum ReportDimensions {
  ProductPath = 'product_path',
  ProductName = 'product_name',
  ProductID = 'product_id',
  ProductVariant = 'product_variant',
  CampaignID = 'campaign_id',
  SubID1 = 'sub_id_1',
  SubID2 = 'sub_id_2',
  SubID3 = 'sub_id_3',
  OSName = 'os_name',
  StepImpressions = 'step_name',
  CancelReason = 'cancel_reason',
  Brand = 'campaign_name',
  InputName = 'input_name',
  CRMCampaignName = 'crm_campaign_name',
  CRMCampaignID = 'crm_campaign_id',
  CRMCampaignNameID = 'crm_campaign_name_id',
  BaseProductNameID = 'base_product_name_id',
  BaseProductName = 'base_product_name',
  BaseProductID = 'base_product_id',
  SessionID = 'username',
  CustomerID = 'customer_id',
  OrderID = 'order_id',
  Hour = 'hour',
  Week = 'week',
  Month = 'month',
  Year = 'year',
  RefundQuantity = 'item_refund_quantity',
  AmountPaid = 'amount_paid',
  RefundAmount = 'refund_amount',
  ParitalRefundAmount = 'item_partial_refund_amount',
  FullRefundAmount = 'full_refund_amount',
  CustomerCount = 'customer_count',
  OrdersCount = 'orders_count',
  PathChannel = 'source',
  TrafficSource = 'tracking_source',
  SourceSub1 = 'sid1',
  SourceSub2 = 'sid2',
  SourceSub3 = 'sid3',
  CustomerName = 'customer_name',
  CustomerEmail = 'customer_email',
  CustomerPhone = 'phone',
  Error = 'error',
  CRMNote = 'note',
  PathName = 'path_name',
  Impressions = 'impressions',
  HoldSaves = 'hold_saves',
  SubscriptionSaves = 'subscription_saves',
  RmaSaves = 'rma_saves',
  VideoRecording = 'recording_url',
  Affiliate = 'aff_id',
  AffSub1 = 'sub1',
  AffSub2 = 'sub2',
  AffSub3 = 'sub3',
  Country = 'country',
  DeviceType = 'device_type',
  BrowserName = 'browser_name',
  DeviceOSVersion = 'os_version',
  DeviceBrand = 'mobile_vendor',
  DeviceModel = 'mobile_model',
  IPAddress = 'ip_address',
  SessionActionResult = 'action_result',
  SessionResult = 'result',
  SessionActionStatus = 'session_action_status',
  SessionQuantity = 'session_count',
  FailedTries = 'failed_tries',
  Tests = 'exclude_tests',
  AllZeroes = 'exclude_zeroes',
  AlertSource = 'alert_source',
  BillingCycle = 'billing_cycle',
  BillingIntervalDays = 'billing_interval_days',
  OfferType = 'offer_type',
  OfferName = 'offer_name',
  CardBIN = 'card_bin',
  CardType = 'card_type',
  CardLast4 = 'card_last4',
  ChargebackDate = 'chargeback_date',
  MerchantID = 'merchant_id',
  MIDNumber = 'mid_number',
  PaymentMethod = 'payment_source',
  RefundDate = 'refund_date',
  RequestType = 'request_type',
  SolvpathSessionID = 'sp_session_id',
  SessionSource = 'sp_session_source',
  SolvpathMatchedType = 'matched_status',
  TransactionAmount = 'amount',
  TransactionID = 'transaction_id',
  TransactionDate = 'created',
  TransactionType = 'transaction_type',
  AlertRatio = 'alert_ratio',
  ChargebackRatio = 'chargeback_ratio',
  DisputeCount = 'dispute_count',
  DsiputeRatio = 'dispute_ratio',
  TimePeriod = 'time_period',
  HoldPath = 'hold_path',
  RMAPath = 'rma_path',
  SubscriptionPath = 'subscription_path',
  HoldIntent = 'hold_intent',
  SubscriptionIntent = 'subscription_intent',
  RMAIntent = 'rma_intent',
  LastHoldStep = 'last_hold_step',
  LastRMAStep = 'last_rma_step',
  LastSubscriptionStep = 'last_subscription_step',
  LastHoldInput = 'last_hold_input',
  LastRMAInput = 'last_rma_input',
  LastSubscriptionInput = 'last_subscription_input',
  CustomerStage = 'customer_stage',
  ProductRole = 'product_role',
  CancelReasonCategory = 'cancel_reason_category',
  CancelReasonCategoryName = 'cancel_reason_category_name',
  DeviceBrandFilter = 'device_brand',
  CRMName = 'crm_name',
  CRMID = 'crm_id',
  AvgMrrSaved = 'avg_mrr_saved',
  SubscriptionAudienceName = 'subscription_audience_name',
  SubscriptionAudienceID = 'subscription_audience_id',
  HoldAudienceName = 'hold_audience_name',
  HoldAudienceID = 'hold_audience_id',
  RmaAudienceName = 'rma_audience_name',
  RmaAudienceID = 'rma_audience_id',
  RetentionSummary = 'retention_summary',
  ProductNameID = 'product_name_id',
  Position = 'position',
  JourneyID = 'journey_id',
  IntentType = 'intent_type',
  CanceledWithOrder = 'canceled_with_order',
  Channel = 'channel',
  Moment = 'moment',
  SessionType = 'session_type',
  IdentificationStatus = 'identification_status',
  Intent = 'intent',
  IntentID = 'intent_id',
  IntentName = 'intent_name',
  ResultLabel = 'result_label',
  SID1 = 'sid_1',
  SID2 = 'sid_2',
  SID3 = 'sid_3',
  Campaign = 'campaign',
  MerchantProfile = 'merchant_profile',
  MerchantProfileID = 'merchant_profile_id',
  MerchantProfileName = 'merchant_profile_name',
  Product = 'product',
  Outcome = 'outcome',
  LinkType = 'link_type',
  FirstIntent = 'first_intent',
  CRM = 'crm',
  OriginatorChannel = 'originator_channel',
  Sessions = 'sessions',
  Matched = 'matched',
  LinkClicks = 'link_clicks',
  ExcludeDuplicateViews = 'exclude_duplicate_views',
}

export const ReportDimensionLabels: { [key: string]: string } = {
  [ReportDimensions.CancelReason]: 'Cancel Reason',
  [ReportDimensions.OfferType]: 'Offer Type',
  [ReportDimensions.OfferName]: 'Offer Name',
  [ReportDimensions.ProductNameID]: 'Camp Product',
  [ReportDimensions.BaseProductNameID]: 'Base Product',
  [ReportDimensions.CRMCampaignName]: 'Campaign',
  [ReportDimensions.CRMCampaignNameID]: 'Campaign',
  [ReportDimensions.CustomerStage]: 'Customer Stage',
  [ReportDimensions.SubscriptionPath]: 'Product Path',
  [ReportDimensions.HoldPath]: 'Product Path',
  [ReportDimensions.RMAPath]: 'Product Path',
  [ReportDimensions.BillingCycle]: 'Billing Cycle',
  [ReportDimensions.BillingIntervalDays]: 'Billing Frequency',
  [ReportDimensions.Moment]: 'Moment',
  [ReportDimensions.Outcome]: 'Lookup Outcome',
  [ReportDimensions.LinkType]: 'Link Type',
  [ReportDimensions.FirstIntent]: 'First Intent',
};

export enum OverviewTab {
  Retention = 1,
  OfferGroup = 2,
}

export enum ChatbotIntents {
  OTHER = 0,
  CANCEL_ORDER = 1,
  CANCEL_SUBSCRIPTION = 2,
  CHANGE_SHIPPING_FREQUENCY = 3,
  SKIP_A_SHIPMENT = 4,
  CHANGE_BILLING_DATE = 5,
  REVISE_ORDER = 6,
  NEW_SALE = 7,
  REFUND_REQUEST = 8,
  RETURN_ORDER = 9,
  EXCHANGE_ORDER = 10,
  REORDER = 11,
  REACTIVATE_SUBSCRIPTION = 12,
  PAUSE_SUBSCRIPTION = 13,
  UPDATE_SHIPPING_INFORMATION = 14,
  UPDATE_PAYMENT_INFORMATION = 15,
  CHECK_ORDER_STATUS = 16,
  TRACK_ORDER = 17,
  TROUBLESHOOT_PRODUCT = 18,
  CHECK_PRODUCT_INFORMATION = 19,
  POLICIES_AND_TERMS = 20,
  CONTACT_SUPPORT = 21,
  MODIFY_ACCOUNT_DETAILS = 22,
  MANAGE_PAYMENT_METHOD = 23,
  TRIAL_RELATED_QUERIES = 24,
  EXTEND_TRIAL_PERIOD = 25,
}

export let ChatbotIntentLabels = {};
ChatbotIntentLabels[ChatbotIntents.OTHER] = 'Other';
ChatbotIntentLabels[ChatbotIntents.CANCEL_ORDER] = 'Cancel Order';
ChatbotIntentLabels[ChatbotIntents.CANCEL_SUBSCRIPTION] = 'Cancel Subscription';
ChatbotIntentLabels[ChatbotIntents.CHANGE_SHIPPING_FREQUENCY] = 'Change Shipping Frequency';
ChatbotIntentLabels[ChatbotIntents.SKIP_A_SHIPMENT] = 'Skip a Shipment';
ChatbotIntentLabels[ChatbotIntents.CHANGE_BILLING_DATE] = 'Change Billing Date';
ChatbotIntentLabels[ChatbotIntents.REVISE_ORDER] = 'Revise Order';
ChatbotIntentLabels[ChatbotIntents.NEW_SALE] = 'New Sale';
ChatbotIntentLabels[ChatbotIntents.REFUND_REQUEST] = 'Refund Request';
ChatbotIntentLabels[ChatbotIntents.RETURN_ORDER] = 'Return Order';
ChatbotIntentLabels[ChatbotIntents.EXCHANGE_ORDER] = 'Exchange Order';
ChatbotIntentLabels[ChatbotIntents.REORDER] = 'Reorder';
ChatbotIntentLabels[ChatbotIntents.REACTIVATE_SUBSCRIPTION] = 'Reactivate Subscription';
ChatbotIntentLabels[ChatbotIntents.PAUSE_SUBSCRIPTION] = 'Pause Subscription';
ChatbotIntentLabels[ChatbotIntents.UPDATE_SHIPPING_INFORMATION] = 'Update Shipping Information';
ChatbotIntentLabels[ChatbotIntents.UPDATE_PAYMENT_INFORMATION] = 'Update Payment Information';
ChatbotIntentLabels[ChatbotIntents.CHECK_ORDER_STATUS] = 'Check Order Status';
ChatbotIntentLabels[ChatbotIntents.TRACK_ORDER] = 'Track Order';
ChatbotIntentLabels[ChatbotIntents.TROUBLESHOOT_PRODUCT] = 'Troubleshoot Product';
ChatbotIntentLabels[ChatbotIntents.CHECK_PRODUCT_INFORMATION] = 'Check Product Information';
ChatbotIntentLabels[ChatbotIntents.POLICIES_AND_TERMS] = 'Policies and Terms';
ChatbotIntentLabels[ChatbotIntents.CONTACT_SUPPORT] = 'Contact Support';
ChatbotIntentLabels[ChatbotIntents.MODIFY_ACCOUNT_DETAILS] = 'Modify Account Details';
ChatbotIntentLabels[ChatbotIntents.MANAGE_PAYMENT_METHOD] = 'Manage Payment Method';
ChatbotIntentLabels[ChatbotIntents.TRIAL_RELATED_QUERIES] = 'Trial Related Queries';
ChatbotIntentLabels[ChatbotIntents.EXTEND_TRIAL_PERIOD] = 'Extend Trial Period';

export enum ChatbotSentiments {
  NEGATIVE = 0,
  NEUTRAL = 1,
  POSITIVE = 2,
  THREAT = 3,
}

export let ChatbotSentimentLabels = {};
ChatbotSentimentLabels[ChatbotSentiments.NEGATIVE] = 'Negative';
ChatbotSentimentLabels[ChatbotSentiments.NEUTRAL] = 'Neutral';
ChatbotSentimentLabels[ChatbotSentiments.POSITIVE] = 'Positive';
ChatbotSentimentLabels[ChatbotSentiments.THREAT] = 'Threat';

export enum ReportVersion {
  Postgres = 1,
  Clickhouse = 2,
}

export enum ReportMode {
  Sessions = 'sessions',
  Customer = 'customer',
}

export interface ReportRow {
  [column: string]: string | number | null;
}

export interface ReportFilterValues {
  [key: string]: string | number | boolean | Array<string | number>;
}

export interface ReportFieldEntry {
  label: string;
  custom_label?: string;
  summary_label?: string;
  summaryHelpText?: string;
  detailHelpText?: string;
  getter: Function;
}

export type ReportFieldData = { [key: string]: ReportFieldEntry };

export interface ProductResult {
  id: number;
  name: string;
  campaign_product_id: string;
}

export interface BaseFilterOptionsQuery {
  accounts: number[];
  date_range: object;
  timezone: string;
  report_type: number;
  report_version: number;
}

export interface ProductsFilterOptionsQuery extends BaseFilterOptionsQuery {
  grouped_fields: ReportDimensions[];
  page: number;
  page_size: number;
  search?: string;
  search_field?: ReportDimensions;
}

export interface CRMCampaignsFilterOptionsQuery extends BaseFilterOptionsQuery {
  grouped_fields: ReportDimensions[];
}

export interface ProductFilterResult {
  [ReportDimensions.ProductID]: number;
  [ReportDimensions.ProductName]: string;
}

export interface CRMCampaignFilterResult {
  [ReportDimensions.CRMCampaignID]: number;
  [ReportDimensions.CRMCampaignName]: string;
}

// ─── Customer Support Report ──────────────────────────────────────────────────

export const IdentificationStatusLabels = ['Unidentified', 'Matched not verified', 'Verified', 'MFA failed'];

export const MomentLabels = [
  'None',
  'Order Pending',
  'Order Shipped',
  'Subscription Active',
  'Subscription Cancelled',
  'Payment Issue',
  'In Trial',
];

// ─── Resolve Report ───────────────────────────────────────────────────────────

export interface ResolveExternalLink {
  link_type: string;
  clicks: number;
  share: number;
}

export interface ResolveExternalLinks {
  results: ResolveExternalLink[];
  total_clicks: number;
  click_rate: number;
}

export interface ResolveSourceBreakdownRow {
  id: string | number;
  name: string;
  quantity: number;
  ctr: number;
}

export interface ResolveSourceBreakdown {
  product: ResolveSourceBreakdownRow[];
  campaign: ResolveSourceBreakdownRow[];
  moment: ResolveSourceBreakdownRow[];
}

export interface ResolveBuyAgainItem {
  id: string | number;
  name: string;
  quantity: number;
  revenue: number;
}

export interface ResolveBuyAgain {
  visitors: number;
  sales: number;
  revenue: number;
  conversion_rate: number;
  aov: number;
  campaigns_originated: ResolveBuyAgainItem[];
  top_products: ResolveBuyAgainItem[];
}

export interface ResolveRequestSourceRow {
  id: string | number;
  name: string;
  quantity: number;
  share: number;
}

export interface ResolveRequestOutcomeRow {
  outcome: string;
  count: number;
  amount: number;
}

export interface ResolveRequestRefund {
  total_requests: number;
  total_billed: number;
  total_refunded: number;
  total_saved: number;
  save_rate: number;
  request_source: ResolveRequestSourceRow[];
  request_outcomes: ResolveRequestOutcomeRow[];
}

export interface ResolveSummaryResponse {
  overview: { [metric: string]: number };
  overview_trend?: { [metric: string]: number | null };
  external_links?: ResolveExternalLinks;
  top_moments: PortalMomentRow[];
  source_breakdown?: ResolveSourceBreakdown;
  top_intents: TopIntentRow[];
  buy_again?: ResolveBuyAgain;
  request_refund?: ResolveRequestRefund;
}

export interface ResolveSummaryQuery {
  report_type: number;
  date_range: { startDate: string; endDate: string };
  compare_date_range?: { startDate: string; endDate: string };
  timezone: string;
  accounts: number[];
  filters: { [key: string]: number | string | Array<number | string> };
}

export enum ResolveLinkType {
  ViewOrder = 'VIEW_ORDER',
}

export const ResolveLinkTypeLabels: { [key: string]: string } = {
  [ResolveLinkType.ViewOrder]: 'View Order',
};

// ─── Gateway Performance Report V3 ─────────────────────────────────────────────

export enum GatewayDriverStatus {
  Live = 'live',
  Deferred = 'deferred',
}

export interface ReportOverviewCard {
  key: string;
  label: string;
  value: number;
  display?: string;
  helpText?: string;
}

export interface ReportPanelColumn<TKey extends string = string> {
  key: TKey;
  label: string;
  sortable: boolean;
  isPercent: boolean;
  helpText: string;
}

export enum TopIntentColumn {
  IntentName = 'intent_name',
  SessionCount = 'session_count',
  Share = 'share',
  AutomationRate = 'automation_rate',
}

export type TopIntentColumnDef = ReportPanelColumn<TopIntentColumn>;

export interface CustomerSupportSummaryResponse {
  overview: { [metric: string]: number };
  overview_trend: { [metric: string]: number | null };
  top_intents: TopIntentRow[];
  portal_moments: PortalMomentRow[];
  portal_actions: PortalActionsResponse;
}

export interface TopIntentRow {
  intent_id: number;
  intent_name: string;
  session_count: number;
  share: number;
  automation_rate?: number;
}

export enum PortalMomentColumn {
  MomentName = 'moment_name',
  SessionCount = 'session_count',
  Share = 'share',
}

export type PortalMomentColumnDef = ReportPanelColumn<PortalMomentColumn>;

export interface PortalMomentRow {
  moment_id: number;
  moment_name: string;
  session_count: number;
  share: number;
}

export interface PortalActionBreakdownRow {
  value: string;
  action_count: number;
  action_share: number;
  session_count: number;
  session_share: number;
}

export interface PortalActionRow {
  action_type: string;
  action_name: string;
  action_count: number;
  action_share: number;
  session_count: number;
  session_share: number;
  breakdown: PortalActionBreakdownRow[];
}

export interface PortalActionsResponse {
  results: PortalActionRow[];
  pending: boolean;
  reason?: string;
}

export interface GatewayOverviewCardsResponse {
  cards: ReportOverviewCard[];
}

export interface GatewayLiveDriverCard {
  key: string;
  label: string;
  status: GatewayDriverStatus.Live;
  [segmentKey: string]: any;
}

export interface GatewayDeferredDriverCard {
  key: string;
  label: string;
  status: GatewayDriverStatus.Deferred;
  value: null;
  reason: string;
}

export interface GatewayDetailsTableResponse {
  results?: object[];
  summary_row?: object;
  has_total_row?: boolean;
  count?: number;
  page?: number;
  num_pages?: number;
}

export interface GatewayFilterOption {
  key: string;
  label: string;
  type: string;
  status?: string;
  values?: string[];
  reason?: string;
}

export type GatewayPerformanceDriver = GatewayLiveDriverCard | GatewayDeferredDriverCard;

export interface GatewayPerformanceDriversResponse {
  cards: GatewayPerformanceDriver[];
}

export interface GatewayTopBar {
  brands: { id: number; name: string }[];
  gateways: { id: number; name: string }[];
  stages: string[];
  count_types: { key: string; label: string }[];
}

export interface GatewayFilterOption {
  key: string;
  label: string;
  type: string;
  values?: string[];
  status?: string;
  reason?: string;
}

export interface GatewayFilterOptionsResponse {
  top_bar: GatewayTopBar;
  filters: GatewayFilterOption[];
}

export interface GatewayDimensionOption {
  key: string;
  label: string;
  value_type?: string;
  values?: string[];
  status?: string;
  reason?: string;
}

export interface GatewayDimensionGroup {
  key: string;
  label: string;
  dimensions: GatewayDimensionOption[];
}

export interface GatewayDimensionOptionsResponse {
  groups: GatewayDimensionGroup[];
}
export interface OfferGroupItem {
  offer_type: number;
  offer_id: string;
  offer_name: string;
  position: number;
  total_impressions: number;
  total_accepted: number;
  total_rejections: number;
  accepted_pct: number;
  avg_mrr_saved: number;
  subscription_path_id?: number;
  subscription_intent?: number;
  subscription_funnel_type?: number | null;
  hold_path_id?: number;
  hold_intent?: number;
  hold_funnel_type?: number | null;
  rma_path_id?: number;
  rma_intent?: number;
  rma_funnel_type?: number | null;
}

// ─── Customer Journey Report V3 ────────────────────────────────────────────────

// Return is a URL-only type (opened from the Return report); the API knows it as an order journey.
export enum CustomerJourneyType {
  Order = 'order',
  Subscription = 'subscription',
  Return = 'return',
}

export const CustomerJourneyTypeLabels: { [type: string]: string } = {
  [CustomerJourneyType.Order]: 'Order',
  [CustomerJourneyType.Subscription]: 'Subscription',
};

export enum CustomerJourneyIntentType {
  Retention = 'retention',
  Return = 'return',
  Support = 'support',
}

export const CustomerJourneyIntentTypeLabels: { [type: string]: string } = {
  [CustomerJourneyIntentType.Retention]: 'Retention',
  [CustomerJourneyIntentType.Return]: 'Return',
  [CustomerJourneyIntentType.Support]: 'Support',
};

export enum CustomerJourneyFilterType {
  Enum = 'enum',
  JourneyItems = 'journey_items',
  Bool = 'bool',
}

export interface CustomerJourneyItemOption {
  id: number;
  name: string | null;
}

export interface CustomerJourney {
  journey_id: number;
  journey_type: CustomerJourneyType;
  order_id: string | null;
  subscription_id: string | null;
  customer_id: string | null;
  brand: string | null;
  products: string[];
  item_options: CustomerJourneyItemOption[];
  items: number;
  session_count: number;
  intent_count: number;
  support_contacts: number;
  span_days: number | null;
  status: string | null;
  primary_intent: string | null;
  primary_intent_type: CustomerJourneyIntentType | null;
  journey_outcome: string | null;
  items_kept: number | null;
  items_total: number | null;
  return_outcome: string | null;
}

export interface CustomerJourneyRow {
  session_id: number;
  session_started: string;
  parent_session_id: number | null;
  link: string;
  channel: string | null;
  support_contact: string | null;
  is_support: boolean;
  session_outcome: string | null;
  item_id: number | null;
  item: string | null;
  lifecycle: string | null;
  intent_type: CustomerJourneyIntentType | null;
  intent: string | null;
  reason: string | null;
  offer: string | null;
  outcome: string | null;
  [dimension: string]: string | number | boolean | null;
}

export interface CustomerJourneyDetailResponse {
  journey: CustomerJourney;
  results: CustomerJourneyRow[];
  count: number;
  page: number;
  num_pages: number;
}

export interface CustomerJourneyDimension {
  key: string;
  label: string;
  default: boolean;
}

export interface CustomerJourneyDimensionGroup {
  key: string;
  label: string;
  dimensions: CustomerJourneyDimension[];
}

export interface CustomerJourneyFilterValue {
  value: string | number;
  label: string;
}

export interface CustomerJourneyFilter {
  key: string;
  label: string;
  type: CustomerJourneyFilterType;
  values?: CustomerJourneyFilterValue[];
}

export interface CustomerJourneyOptionsResponse {
  groups: CustomerJourneyDimensionGroup[];
  filters: CustomerJourneyFilter[];
}

export interface CustomerJourneyQuery {
  journey_id: number;
  journey_type: CustomerJourneyType;
  accounts: number[];
  fields: string[];
  filters: { [key: string]: string[] | number[] | boolean };
  ordering: string[];
}

export interface CustomerJourneyBoolFilter {
  key: string;
  label: string;
  checked: boolean;
}

export interface CustomerJourneyCell {
  label: string;
  value: string;
}
